/* ============================================================
   KD CART DRAWER — khaizen
   ============================================================ */

(function () {
  'use strict';

  /* Prevent SlideCart by AMP from opening — KD drawer owns all cart interactions */
  window.SLIDECART_OPEN = function () { return false; };

  var SECTION_ID = 'cart-drawer';

  /* ── Intercept ALL /cart/add calls (fetch + XHR) ───────────
     Named params instead of `arguments` to avoid strict-mode issues.
     XHR covers apps (KaChing Bundles, etc.) that bypass window.fetch. */
  (function () {
    /* fetch intercept */
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');

      if (url && url.indexOf('/cart/add') !== -1 && window._kdGiftVariantIds && init && init.body) {
        try {
          var body = typeof init.body === 'string' ? JSON.parse(init.body) : null;
          if (body && window._kdGiftVariantIds.indexOf(parseInt(body.id, 10)) !== -1) {
            if (!body.properties || body.properties._cart_drawer_gift !== 'true') {
              return Promise.reject(new Error('direct-gift-blocked'));
            }
          }
        } catch (e) {}
      }

      var p = origFetch.call(window, input, init);
      if (url && url.indexOf('/cart/add') !== -1) {
        p.then(function (r) {
          if (r.ok) {
            var kd = document.querySelector('kd-cart-drawer');
            if (kd && typeof kd.open === 'function') kd.open();
          }
        }).catch(function () {});
      }
      return p;
    };

    /* XHR intercept — catches apps that captured fetch before this script */
    var origXhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (method && method.toUpperCase() === 'POST' && url && url.indexOf('/cart/add') !== -1) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            var kd = document.querySelector('kd-cart-drawer');
            if (kd && typeof kd.open === 'function') kd.open();
          }
        });
      }
      return origXhrOpen.apply(this, arguments);
    };
  })();

  /* ── Helpers ── */
  function qs(sel, root) { return (root || document).querySelector(sel); }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('Network error: ' + r.status);
      return r.json();
    });
  }

  function buildStorefrontUrl(path, params) {
    var url = new URL(path, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);

    currentParams.forEach(function (value, key) {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    });

    if (params) {
      Object.keys(params).forEach(function (key) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          url.searchParams.set(key, params[key]);
        }
      });
    }

    return url.pathname + url.search;
  }

  function money(cents) {
    var eur = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + eur;
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.m-cart-count-bubble, [data-kd-header-count]').forEach(function (el) {
      if (count > 0) {
        el.textContent = count;
        el.classList.remove('m:hidden', 'hidden');
      } else {
        el.textContent = '0';
        el.classList.add('m:hidden');
      }
    });
  }

  /* ── Cart API ── */
  function cartChange(line, quantity) {
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function cartAdd(id, quantity, properties) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1, properties: properties || {} })
    });
  }

  function cartRemoveByKey(key) {
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [key]: 0 } })
    });
  }

  /* ============================================================
     KdCartDrawer custom element
     ============================================================ */
  class KdCartDrawer extends HTMLElement {
    connectedCallback() {
      /* Close button */
      var closeBtn = qs('.kd-cart__close', this);
      if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));

      /* Overlay click */
      this.addEventListener('click', function (e) {
        if (!e.target.closest('.kd-cart__panel')) this.close();
      }.bind(this));

      /* Cart icon click — open this drawer instead */
      this._bindCartIcons();

      /* ATC from product forms — hook Minimog + FoxKit pubsub */
      this._bindATCEvents();

      /* Gift claim */
      this._bindGiftClaim();

      /* Standalone promo gift claim */
      this._bindPromoGiftClaim();

      /* Quantity / remove within drawer */
      this._bindItemControls();
    }

    /* ── Open / Close ── */
    open() {
      if (this.classList.contains('kd-cart--active')) { this.refresh(); return; }
      this.classList.add('kd-cart--active');
      document.documentElement.classList.add('kd-cart-open');
      var self = this;
      this.refresh().then(function () {
        requestAnimationFrame(function () {
          self.classList.add('kd-cart--visible');
          var track = self.querySelector('.kd-cart__sp-track');
          if (track) {
            track.style.animation = 'none';
            track.offsetHeight; // force reflow so iOS Safari restarts the animation
            track.style.animation = '';
          }
        });
      });
    }

    close() {
      this.classList.remove('kd-cart--visible');
      document.documentElement.classList.remove('kd-cart-open');
      var self = this;
      setTimeout(function () {
        self.classList.remove('kd-cart--active');
      }, 310);
    }

    /* ── Section refresh ── */
    refresh() {
      var self = this;
      var sectionId = this.dataset.kdSectionId || SECTION_ID;
      var cartPath = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      return fetch(buildStorefrontUrl(cartPath, { sections: sectionId }))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');

          self._replace('[data-kd-cart-items]', doc);
          self._replace('[data-kd-footer-inner]', doc);
          self._replace('[data-kd-cart-totals]', doc);
          self._replace('[data-kd-cart-discounts]', doc);

          /* Cart count — update drawer display and header icon */
          var countEl = doc.querySelector('[data-kd-cart-count]');
          var myCountEl = qs('[data-kd-cart-count]', self);
          if (countEl && myCountEl) myCountEl.innerHTML = countEl.innerHTML;
          if (countEl) {
            var countMatch = countEl.textContent.match(/\d+/);
            updateHeaderCount(countMatch ? parseInt(countMatch[0], 10) : 0);
          }

          /* Empty state toggle */
          var cartItems = qs('[data-kd-cart-items]', self);
          var hasItems = cartItems && cartItems.querySelector('.kd-item, .kd-gift-card');
          self.classList.toggle('kd-cart--empty', !hasItems);

          /* Restore gift claim socket when section refresh omits unsaved editor product config */
          self._restoreGiftClaim();

          self._syncRecCards();

          self.dispatchEvent(new CustomEvent('kd-cart:refreshed', { bubbles: true }));
        })
        .catch(function (err) { console.error('[KdCart] refresh error', err); });
    }

    _replace(selector, doc) {
      var newEl = doc.querySelector(selector);
      var curEl = qs(selector, this);
      if (newEl && curEl) curEl.innerHTML = newEl.innerHTML;
    }

    _restoreGiftClaim() {
      var itemsRoot = qs('[data-kd-cart-items]', this);
      if (!itemsRoot) return;
      if (itemsRoot.querySelector('[data-kd-gift-claim], [data-kd-gift-line]')) return;

      var bar = itemsRoot.querySelector('.kd-fsb--gift-unlocked');
      if (!bar) return;

      var template = qs('template[data-kd-gift-template]', this);
      if (!template || !template.innerHTML.trim()) return;

      bar.insertAdjacentHTML('afterend', template.innerHTML);
    }

    /* ── Cart icon binding ── */
    _bindCartIcons() {
      var self = this;

      function bindOne(el) {
        /* Clone removes ALL existing event listeners (Minimog, SlideCart, FoxKit) */
        var clone = el.cloneNode(true);
        clone.setAttribute('href', 'javascript:void(0)');
        clone.setAttribute('role', 'button');
        clone.setAttribute('aria-haspopup', 'dialog');
        clone.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.open();
        });
        el.parentNode.replaceChild(clone, el);
      }

      document.querySelectorAll('.m-cart-icon-bubble, [data-cart-trigger]').forEach(bindOne);
    }

    /* ── ATC event binding ── */
    _bindATCEvents() {
      var self = this;

      /* Secondary triggers — catch anything the fetch/XHR intercept misses */
      ['cart:updated', 'cart:added', 'product-ajax:added'].forEach(function (evt) {
        document.addEventListener(evt, function () { self.open(); });
      });

      /* Minimog pubsub — refresh if drawer is already open */
      if (window.MinimogEvents && window.MinimogTheme) {
        try {
          MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, function () {
            if (self.classList.contains('kd-cart--active')) self.refresh();
          });
        } catch (e) { /* noop */ }
      }
    }

    /* ── Item controls (qty + remove) ── */
    _bindItemControls() {
      var self = this;

      this.addEventListener('click', function (e) {
        /* Qty button */
        var qtyBtn = e.target.closest('[data-kd-qty-btn]');
        if (qtyBtn) {
          e.preventDefault();
          var container = qtyBtn.closest('.kd-qty');
          if (!container) return;
          var input = container.querySelector('input[data-kd-qty]');
          if (!input) return;
          var delta = qtyBtn.dataset.kdQtyBtn === 'plus' ? 1 : -1;
          var newVal = Math.max(0, parseInt(input.value, 10) + delta);
          input.value = newVal;
          self._setLoading(true);
          cartChange(parseInt(input.dataset.index, 10), newVal)
            .then(function (cart) {
              updateHeaderCount(cart.item_count);
              return self.refresh();
            })
            .finally(function () { self._setLoading(false); });
          return;
        }

        /* Remove button */
        var removeBtn = e.target.closest('[data-kd-remove]');
        if (removeBtn) {
          e.preventDefault();
          self._setLoading(true);
          cartChange(parseInt(removeBtn.dataset.index, 10), 0)
            .then(function (cart) {
              updateHeaderCount(cart.item_count);
              return self.refresh();
            })
            .finally(function () { self._setLoading(false); });
        }
      });
    }

    _syncRecCards() {
      var recsBody = qs('[data-kd-recs-body]', this);
      var recsCarousel = qs('[data-kd-recs-carousel]', this);
      if (!recsBody || !recsCarousel) return;

      var inCart = new Set();
      var cartItems = qs('[data-kd-cart-items]', this);
      if (cartItems) {
        cartItems.querySelectorAll('[data-variant-id]').forEach(function (el) {
          var vid = parseInt(el.dataset.variantId, 10);
          if (vid) inCart.add(vid);
        });
      }

      var cards = recsCarousel.querySelectorAll('[data-kd-rec-variants]');
      var visibleCount = 0;
      cards.forEach(function (card) {
        var variants = (card.dataset.kdRecVariants || '').split(',').map(Number).filter(Boolean);
        var matched = variants.some(function (vid) { return inCart.has(vid); });
        card.hidden = matched;
        if (!matched) visibleCount++;
      });

      recsBody.hidden = (visibleCount === 0);
    }

    _setLoading(on) {
      this.classList.toggle('kd-cart--loading', on);
    }

    /* ── Gift claim ── */
    _bindGiftClaim() {
      var self = this;

      /* Claim button click */
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gift-claim-btn]');
        if (!btn) return;
        e.preventDefault();
        var form = btn.closest('[data-gift-claim-form]');
        self._submitGift(form, btn);
      });

      /* Variant select change → auto-claim */
      this.addEventListener('change', function (e) {
        var select = e.target.closest('[data-gift-claim-form] select[name="variant_id"]');
        if (!select) return;
        var form = select.closest('[data-gift-claim-form]');
        self._submitGift(form, select);
      });
    }

    _submitGift(form, trigger) {
      if (!form || form.dataset.loading === 'true') return;
      var variantSelect = form.querySelector('select[name="variant_id"]');
      var variantInput = form.querySelector('input[name="variant_id"]');
      var variantId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : null);
      if (!variantId) { if (variantSelect) variantSelect.focus(); return; }

      form.dataset.loading = 'true';
      if (trigger) trigger.disabled = true;

      var self = this;
      cartAdd(parseInt(variantId, 10), 1, { _cart_drawer_gift: 'true' })
        .then(function () {
          var giftClaim = form.closest('[data-kd-gift-claim]');
          if (giftClaim) giftClaim.remove();
          return fetchJSON('/cart.js');
        })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          return self.refresh();
        })
        .catch(function () {
          delete form.dataset.loading;
          if (trigger) trigger.disabled = false;
        });
    }

    /* ── Standalone promo gift (Shopify discount controlled) ── */
    _bindPromoGiftClaim() {
      var self = this;
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-promo-gift-claim-btn]');
        if (!btn) return;
        e.preventDefault();
        self._submitPromoGift(btn.closest('[data-promo-gift-claim-form]'), btn);
      });
    }

    _submitPromoGift(form, trigger) {
      if (!form || form.dataset.loading === 'true') return;
      var variantSelect = form.querySelector('select[name="variant_id"]');
      var variantInput = form.querySelector('input[name="variant_id"]');
      var variantId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : null);
      var error = form.querySelector('[data-promo-gift-error]');

      if (!variantId) {
        if (variantSelect) variantSelect.focus();
        return;
      }

      form.dataset.loading = 'true';
      trigger.disabled = true;
      if (error) error.hidden = true;
      var promoBlock = form.closest('[data-kd-promo-gift]');
      if (promoBlock) promoBlock.hidden = true;

      var self = this;
      cartAdd(parseInt(variantId, 10), 1, { _cart_drawer_promo_gift: 'true' })
        .then(function () { return fetchJSON('/cart.js'); })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          return self.refresh();
        })
        .catch(function (err) {
          if (promoBlock) promoBlock.hidden = false;
          if (error) {
            error.textContent = form.dataset.discountError;
            error.hidden = false;
          }
          console.error('[KdCart] promo gift error', err);
        })
        .finally(function () {
          delete form.dataset.loading;
          trigger.disabled = false;
        });
    }

    /* ── Gift auto-remove ── */
    checkGiftAutoRemove(rewardThresholdCents) {
      if (!rewardThresholdCents) return;
      var self = this;
      fetchJSON('/cart.js').then(function (cart) {
        var giftKey = null;
        var qualifying = 0;
        cart.items.forEach(function (item) {
          if (item.properties && item.properties._cart_drawer_gift === 'true') {
            giftKey = item.key;
            return;
          }
          if (item.properties && item.properties._cart_drawer_promo_gift === 'true') {
            return;
          }
          if (item.requires_shipping) qualifying += item.final_line_price;
        });
        (cart.cart_level_discount_applications || []).forEach(function (d) {
          qualifying -= d.total_allocated_amount;
        });
        if (giftKey && qualifying < rewardThresholdCents) {
          cartRemoveByKey(giftKey).then(function () { return self.refresh(); });
        }
      });
    }
  }

  if (!customElements.get('kd-cart-drawer')) {
    customElements.define('kd-cart-drawer', KdCartDrawer);
  }

  /* ============================================================
     Rec card: size-select warning + ATC
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kd-rec-atc]');
    if (!btn) return;
    e.preventDefault();

    var form = btn.closest('[data-kd-rec-form]');
    if (!form) return;
    var select = form.querySelector('select[name="id"]');
    var hiddenInput = form.querySelector('input[name="id"]');
    var variantId = select ? select.value : (hiddenInput ? hiddenInput.value : null);

    if (!variantId) {
      /* Warning state */
      if (select) {
        select.classList.add('kd-rec__select--warning');
        var placeholder = select.options[0];
        if (placeholder && !placeholder.value) placeholder.text = select.dataset.warningText || 'Kies eerst een maat';
        select.focus();
      }
      return;
    }

    btn.disabled = true;

    fetchJSON('/cart.js')
      .then(function (cart) {
        var vid = parseInt(variantId, 10);
        var alreadyIn = cart.items.some(function (item) {
          return item.variant_id === vid;
        });
        if (alreadyIn) {
          var drawer = document.querySelector('kd-cart-drawer');
          if (drawer && !drawer.classList.contains('kd-cart--active')) drawer.open();
          return;
        }
        return cartAdd(vid, 1, { _kd_upsell: 'true' }).then(function () {
          var drawer = document.querySelector('kd-cart-drawer');
          if (!drawer) return;
          if (!drawer.classList.contains('kd-cart--active')) drawer.open();
          else drawer.refresh();
        });
      })
      .catch(function (err) { console.error('[KdCart] ATC error', err); })
      .finally(function () { btn.disabled = false; });
  });

  /* Reset warning on select change + update variant label */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-kd-rec-form] select[name="id"]');
    if (!select) return;
    select.classList.remove('kd-rec__select--warning');

    var form = select.closest('[data-kd-rec-form]');
    if (!form) return;

    var btn = form.querySelector('[data-kd-rec-atc]');
    if (btn && select.value) {
      btn.classList.add('kd-rec__atc-btn--ready');
    } else if (btn) {
      btn.classList.remove('kd-rec__atc-btn--ready');
    }

    var variantLabel = form.closest('.kd-rec__info') && form.closest('.kd-rec__info').querySelector('.kd-rec__variant');
    if (variantLabel) {
      var selected = select.options[select.selectedIndex];
      variantLabel.textContent = selected ? selected.text : '';
    }
  });

  /* ============================================================
     Disable Minimog drawer; redirect all opens to KD drawer
     ============================================================ */
  function _suppressMiniDrawerInstance(el) {
    el.open = function () {};
    if (typeof el.renderContents === 'function') {
      el.renderContents = function (parsedState) {
        if (typeof el.updateCartCount === 'function') el.updateCartCount(parsedState.item_count);
        var kdDrawer = document.querySelector('kd-cart-drawer');
        if (kdDrawer) {
          if (!kdDrawer.classList.contains('kd-cart--active')) kdDrawer.open();
          else kdDrawer.refresh();
        }
      };
    }
  }

  /* Patch instance immediately (defer scripts run after DOM is parsed) */
  var _miniDrawer = document.querySelector('m-cart-drawer');
  if (_miniDrawer) _suppressMiniDrawerInstance(_miniDrawer);

  /* Also patch prototype the moment the class is registered */
  if (customElements && customElements.whenDefined) {
    customElements.whenDefined('m-cart-drawer').then(function () {
      var Cls = customElements.get('m-cart-drawer');
      if (!Cls) return;
      Cls.prototype.open = function () {};
      Cls.prototype.renderContents = function (parsedState) {
        if (typeof this.updateCartCount === 'function') this.updateCartCount(parsedState.item_count);
        var kdDrawer = document.querySelector('kd-cart-drawer');
        if (kdDrawer) {
          if (!kdDrawer.classList.contains('kd-cart--active')) kdDrawer.open();
          else kdDrawer.refresh();
        }
      };
    });
  }

  /* Init gift auto-remove listener */
  document.addEventListener('DOMContentLoaded', function () {
    var kdDrawer = document.querySelector('kd-cart-drawer');
    if (kdDrawer) {
      kdDrawer.addEventListener('kd-cart:refreshed', function () {
        var thresholdEl = qs('[data-kd-reward-threshold]', kdDrawer);
        var threshold = thresholdEl ? parseInt(thresholdEl.dataset.kdRewardThreshold, 10) : 0;
        kdDrawer.checkGiftAutoRemove(threshold);
      });
    }
  });

}());
